"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcInputCurrencyBehavior = void 0;
var default_behavior_1 = require("./../../../common/models/default-behavior");
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_input_behavior_1 = require("../bc-input/bc-input-behavior");
var bc_input_currency_constants_1 = require("./bc-input-currency-constants");
var BcInputCurrencyBehavior = (function (_super) {
    __extends(BcInputCurrencyBehavior, _super);
    function BcInputCurrencyBehavior() {
        var _this = _super.call(this) || this;
        _this.value = 0;
        return _this;
    }
    BcInputCurrencyBehavior.setUpAll = function () {
        var inputElements = Array.from(document.querySelectorAll("div[class='".concat(bc_input_currency_constants_1.INPUT_CURRENCY, "']")));
        var elements = [];
        for (var _i = 0, inputElements_1 = inputElements; _i < inputElements_1.length; _i++) {
            var element = inputElements_1[_i];
            var bcInputCurrencyBehavior = new BcInputCurrencyBehavior();
            bcInputCurrencyBehavior.setElement(element);
            bcInputCurrencyBehavior.setUp();
            elements.push(bcInputCurrencyBehavior);
        }
        return elements;
    };
    BcInputCurrencyBehavior.prototype._setUp = function () {
        this.getElement();
        this.addEventListeners();
        this.inputBehavior = new bc_input_behavior_1.BcInputBehavior();
        this.inputBehavior.setElement(this.currencyInput);
        this.inputBehavior.setUp();
        this.value = parseInt(this.currencyInput.value);
    };
    BcInputCurrencyBehavior.prototype.setValue = function (value) {
        if (this.currencyInput) {
            this.currencyInput.value = String(value);
            this.inputBehavior.updateState(null);
        }
    };
    BcInputCurrencyBehavior.prototype.setErrorState = function (isValid) {
        if (isValid) {
            this.currencyInput.classList.remove('bc-input-error');
        }
        else {
            this.currencyInput.classList.add('bc-input-error');
        }
    };
    BcInputCurrencyBehavior.prototype.setSuccessState = function (isSuccess) {
        if (isSuccess) {
            this.currencyInput.classList.add('bc-input-success');
        }
        else {
            this.currencyInput.classList.remove('bc-input-success');
        }
    };
    BcInputCurrencyBehavior.prototype.setDisabled = function (isDisabled) {
        this.currencyInput.disabled = isDisabled;
    };
    BcInputCurrencyBehavior.prototype.getElement = function () {
        this.currencyInput = this.mySelf.querySelector('input[type=number]');
    };
    BcInputCurrencyBehavior.prototype.emitEvent = function () {
        this.value = parseInt(this.currencyInput.value);
        if (this.output) {
            this.output(this.value);
        }
    };
    BcInputCurrencyBehavior.prototype.addEventListeners = function () {
        var _this = this;
        this.currencyInput.addEventListener(common_constants_1.BcCommonConstants.EVENT_INPUT, function () {
            _this.emitEvent();
        });
    };
    return BcInputCurrencyBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcInputCurrencyBehavior = BcInputCurrencyBehavior;
